/* jscs:disable maximumLineLength */

import React from 'react';
import { METRO_URGENT_CARE_FACEBOOK_TRACKING_ID } from '../../config/index';

export default () => (
  <img
    height="1"
    width="1"
    src={`https://www.facebook.com/tr?id=${METRO_URGENT_CARE_FACEBOOK_TRACKING_ID}&ev=PageView&noscript=1`}
  />
);
